export default __webpack_public_path__ + "static/media/h5-section1-tip1.9c8b4096.png";